module.exports = "<p>\n  users-view works!\n</p>\n"